import React from "react";
import { useEffect } from "react";
import Footer from "../components/footer";
import NavbarHome from "../components/navbar-home";
import ContactSatuContent from "../pages/Contacts/contact-satu-content";
import ContactSatuJumbotron from "../pages/Contacts/contact-satu-jumbotron";

export default function ContactSatu() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <NavbarHome />
      <ContactSatuJumbotron />
      <ContactSatuContent />
      <Footer />
    </>
  );
}
